import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.sharing`;
export const INIT = `${SCOPE}/INIT`;
export const GET_SHARING = `${SCOPE}/GET_SHARING`;
export const ADD_ML_SHARING_TAB = `${SCOPE}/ADD_ML_SHARING_TAB`;
